import moment from 'moment';
import 'moment/locale/ja';
import { useMemo } from 'react';
import { propOneOfType, propShape, propStr, } from '../../../helpers/custom-prop-types';
/**
 * Deprecated: 日付をフォーマットするコンポーネント
 * @param props
 * @returns {*}
 * @constructor
 */
const DateText = (props) => {
    const { defaultText, format, value } = props;
    return useMemo(() => (value ? moment(value).format(format) : defaultText), [value, format, defaultText]);
};
DateText.propTypes = {
    defaultText: propStr(),
    format: propStr().isRequired,
    value: propOneOfType([propStr(), propShape()]),
};
DateText.defaultProps = {
    defaultText: '',
    value: '',
};
export default DateText;
